export const variante = {
    init:{
        opacity:1,
        y:0,
    },
    out:{
        opacity:0,
        y:"-20vw",
    }
}

export const transitions = {
    duration:1,
    type: "spring",
    ease:"anticipate",
    stiffness: 50,
    delay:.4
}
